import { Container, Grid, MenuItem, TextField } from '@mui/material';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { TextFieldLoading } from '@/components/form-elements/TextFieldLoading';
import { FullHeightLayout } from '@/components/layouts/FullHeightLayout';
import { useQueryOrganization } from '@/hooks/queries/useQueryOrganization';
import { IndicatorProcessStatus } from '@/services/api/models/IndicatorProcessStatus';

export const AnalysisPage = () => {
  const [consultingCaseLocationId, setConsultingCaseLocationId] = useState('');
  const navigate = useNavigate();
  const { organizationId, indicatorProcessId } = useParams();

  const { data: organization, isLoading } = useQueryOrganization();

  return (
    <FullHeightLayout>
      <Container>
        <Grid container spacing={1} mb={2}>
          <Grid item xs={4}>
            <TextFieldLoading isLoading={isLoading}>
              <TextField
                value={indicatorProcessId || ''}
                label="Prozessname"
                select
                SelectProps={{ native: false }}
                onChange={(event) => {
                  navigate(`/organisation/${organizationId}/wohnstandortanalyse/${event.target.value}` as string);
                }}
              >
                {organization?.processes?.map((process) => (
                  <MenuItem
                    key={process.id}
                    value={process.id}
                    disabled={
                      !(
                        process.status === IndicatorProcessStatus.INDICATORS_APPROVED ||
                        process.status === IndicatorProcessStatus.CALCULATION_DONE
                      )
                    }
                  >
                    {process.name}
                  </MenuItem>
                ))}
              </TextField>
            </TextFieldLoading>
          </Grid>
          <Grid item xs={4}>
            <TextFieldLoading isLoading={isLoading}>
              <TextField
                defaultValue="10"
                label="Anwendungsfall"
                select
                SelectProps={{ native: false }}
                onChange={(event) => setConsultingCaseLocationId(event.target.value)}
              >
                <MenuItem value="10">Alle Anwendungsfälle</MenuItem>
                {organization?.locations?.map(
                  (location) =>
                    location.consultingCaseLocationId && (
                      <MenuItem key={location.id} value={location.consultingCaseLocationId}>
                        {location.name}
                      </MenuItem>
                    ),
                )}
              </TextField>
            </TextFieldLoading>
          </Grid>
        </Grid>
      </Container>
      {indicatorProcessId && (
        <iframe
          src={`https://${
            window.location.hostname === 'localhost' ? 'bmmdev.trafficon.eu' : window.location.host
          }/standortanalyse/?process_id=${indicatorProcessId}&locId=${consultingCaseLocationId}&orgName=${
            organization?.name
          }`}
          title="Wohnstandortanalyse"
          width="100%"
          height="90vh"
          style={{ border: 'none', height: '90vh' }}
        />
      )}
    </FullHeightLayout>
  );
};
